import './BordStatusBadge.scss';

interface IBordStatusBadge {
  label: string;
  dotColor: string;
  textColor?: string;
  customClassName?: string;
}

/**
 * Badge de estado con punto de color y etiqueta.
 * dotColor controla el color del punto y el borde; textColor controla el color del texto.
 * customClassName permite agregar estilos adicionales desde el contexto de uso.
 */
const BordStatusBadge = ({ label, dotColor, textColor, customClassName = '' }: IBordStatusBadge) => (
  <div className={`bordStatusBadge ${customClassName}`.trim()} style={{ borderColor: dotColor }}>
    <span className="statusDot" style={{ backgroundColor: dotColor }} />
    <span className="statusLabel" style={{ color: textColor }}>{label}</span>
  </div>
);

export default BordStatusBadge;
